import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M6.088 1.333h19.779c2.746 1.142 4.146 3.509 4.8 5.069V25.55c-.633 1.543-2.014 3.942-4.756 5.116H6.09c-2.742-1.174-4.123-3.572-4.756-5.116V6.45c.633-1.544 2.014-3.942 4.755-5.116",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M18.66 22.79c-1.13-.724-1.658-2.997-1.625-3.012.052.05 1.097 1.04 2.114 1.635.476.278.628-.161 1.094.254s1.255.547 1.338-.212c.084-.758-.91-.057-1.02-.26-.443-.812-2.116-2.2-2.14-2.294 3.245 1.409 7.64-4.313 3.023-9.595-.133 3.015-2.384 4.618-2.396 5.253-.012.636.987.63.38 1.157-.606.528-.881.364-.916.369-.07-.762.232-1.25-.09-1.526-.324-.275-.984-.48-.773-1.314s2.771-.692 2.67-1.34c-.103-.646-.993-.942-1.572-.992-.325-.028-2.27-.335-2.746 2.815-.476-3.15-2.42-2.843-2.746-2.815-.578.05-1.469.346-1.57.993-.103.647 2.458.505 2.669 1.34.21.834-.45 1.038-.773 1.313-.323.276-.02.764-.091 1.526-.035-.006-.31.159-.916-.369-.606-.527.393-.521.38-1.157-.012-.635-2.263-2.238-2.395-5.253-4.618 5.282-.222 11.004 3.022 9.595-.03.117-2.642 2.263-2.194 2.766.707.794 3.495-1.809 3.58-1.889.034.015-.495 2.288-1.624 3.012.032.442 1.858 1.87 2.657 2.067.8-.196 2.628-1.625 2.66-2.067",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M16 11.333c1.105 0 2-.746 2-1.666S17.105 8 16 8s-2 .746-2 1.667c0 .92.895 1.666 2 1.666",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "m12.215 22.711-3.18-5.745a.333.333 0 1 0-.583.323l3.18 5.745a.333.333 0 1 0 .583-.323"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M22 22a1.333 1.333 0 1 0 0-2.667A1.333 1.333 0 0 0 22 22",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      fillRule: "evenodd",
      d: "m19.193 14.526-.886-.943c-.845.303-1.618.321-2.307-.004-.688.325-1.462.307-2.306.004l-.887.943s.326.415.326 1.073-.137 1.145-.217 1.463-.148.912.034 1.336c.183.424.377.796 1.166 1.103.788.308 1.199.467 1.473.679s.411.381.411.381.137-.17.411-.381c.274-.212.686-.371 1.474-.679.788-.307.982-.679 1.165-1.103s.114-1.018.034-1.336-.216-.805-.216-1.463.325-1.073.325-1.073",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M19.103 18.246h-6.206c-.113-.405-.052-.902.02-1.184.08-.318.216-.806.216-1.463 0-.658-.326-1.073-.326-1.073l.887-.943c.844.303 1.617.321 2.306-.004.689.325 1.462.307 2.307.004l.886.943s-.326.415-.325 1.073c0 .658.137 1.145.216 1.463.07.282.133.779.02 1.184",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M16.721 18.242c.022-.05.265-.186.234-.448-.03-.262-.114-.336 0-.378.057-.02.422.189.803 0 .127-.063.109.378-.044.473-.464.038-.563.332-.572.353h1.004c.004-.008.292-.448.133-1.16-.565-.202-.569-.558-.569-.558q.372-.072.527-.13c.157-.058.262-.316.13-.548-.133-.232-.599-.197-.725-.211-.055-.006-.777.027-.687-.247.09-.275.915-.145 1.03-.165a.37.37 0 0 0 .303-.273c.038-.14-.236-.037-.496-.091-.26-.055-.37.013-.47.054-.098.04-.705.221-.652.555s.357.34.55.378.761.01.8.211-.548.201-.548.201c-.358-.113-1.262-.068-1.262-.068l-.098-.228c-.024-.055.314-.02.353-.16.04-.14-.258-.378-.258-.378s.247-.422.126-.652-.61-.27-.878-.244c-.536.051-.69.27-.623.48.069.21-.139.007-.187-.102-.047-.11-.129-.048-.129.065-.03.286.374.34.368.45s.316.047.309.193c-.248.055-.582.371-.582.371-.272.04-.364-.463-.367-.565-.002-.051.07-.459-.048-.648-.116-.186-.422-.153-.504-.094-.062.044-.23.412-.145.71.071.248.393.436.397.451.01.034.024.187.096.504.033.15.299.317.476.299-.033.434.109.501.109.501.02.261-.249.709-.286.746-.459.048-.524.35-.527.353h1.066s.048-.838.434-.983c.366.072.952-.15.952-.15-.078.39.258.514.201.751-.014.06-.29-.046-.46.03-.087.038-.154.197-.2.352z"
    }
  )
);
var SvgFlagMne = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagMne_default = SvgFlagMne;

export { FlagMne_default as default };
